import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = {
    url: String,
    handle: { type: String, default: ".drag-handle" },
    animation: { type: Number, default: 150 },
    idParam: { type: String, default: "category_ids" },
    idAttribute: { type: String, default: "data-category-id" },
    group: { type: String, default: "" }
  }

  connect() {
    const options = {
      animation: this.animationValue,
      handle: this.handleValue,
      ghostClass: "sortable-ghost",
      chosenClass: "sortable-chosen",
      dragClass: "sortable-drag",
      // モバイルタッチ対応: 長押し150ms後にドラッグ開始
      delay: 150,
      delayOnTouchOnly: true,
      touchStartThreshold: 5,
      forceFallback: true,
      fallbackOnBody: true,
      swapThreshold: 0.65,
      onStart: this.onStart.bind(this),
      onEnd: this.onEnd.bind(this)
    }

    if (this.groupValue) {
      options.group = this.groupValue
      options.onAdd = this.onAdd.bind(this)
    }

    this.sortable = Sortable.create(this.element, options)
  }

  disconnect() {
    if (this.sortable) this.sortable.destroy()
  }

  // ドラッグ開始: カテゴリレベルではメニューリストを折りたたんで要素を小さくする
  onStart(event) {
    if (this.groupValue) return // メニューアイテムレベルでは不要

    this._collapsedElements = []
    this.element.querySelectorAll("[data-collapse-content]").forEach(el => {
      if (el.style.display !== "none") {
        el.style.display = "none"
        this._collapsedElements.push(el)
      }
    })
  }

  // 同一リスト内での並び替え完了
  onEnd(event) {
    // カテゴリレベル: 折りたたみを復元
    if (!this.groupValue && this._collapsedElements) {
      this._collapsedElements.forEach(el => {
        el.style.display = ""
      })
      this._collapsedElements = []
    }

    if (event.from !== event.to) return // カテゴリ間移動はonAddで処理
    if (event.oldIndex === event.newIndex) return
    this.saveOrder(this.element)
  }

  // カテゴリ間移動（別リストへ追加された時）
  onAdd(event) {
    const targetContainer = event.to
    const movedItemId = event.item.getAttribute(this.idAttributeValue)
    const categoryId = targetContainer.dataset.sortableCategoryId

    this.saveOrder(targetContainer, { category_id: categoryId, moved_item_id: movedItemId })
    // 移動元リストも更新
    this.saveOrder(event.from)
    // 件数表示を更新
    this.updateItemCount(event.from)
    this.updateItemCount(event.to)
  }

  // コンテナ内のアイテム数をカウントしてヘッダーとジャンプリンクの件数を更新
  updateItemCount(container) {
    const categoryId = container.dataset.sortableCategoryId
    if (!categoryId) return

    const count = container.querySelectorAll(`[${this.idAttributeValue}]`).length
    // セクションヘッダーの件数 (例: "ビール (2)")
    const section = container.closest(`[id="manage-cat-${categoryId}"]`)
    if (section) {
      const countSpan = section.querySelector("h3 span")
      if (countSpan) countSpan.textContent = `(${count})`
    }
    // ジャンプリンクの件数
    const jumpLink = document.querySelector(`a[href="#manage-cat-${categoryId}"]`)
    if (jumpLink) {
      jumpLink.textContent = jumpLink.textContent.replace(/\(\d+\)/, `(${count})`)
    }
  }

  saveOrder(container, extra = {}) {
    const ids = Array.from(container.children)
      .map(el => el.getAttribute(this.idAttributeValue))
      .filter(Boolean)

    if (ids.length === 0) return

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const url = container.closest("[data-sortable-url-value]")
                  ?.dataset.sortableUrlValue || this.urlValue

    fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
        "Accept": "text/vnd.turbo-stream.html"
      },
      body: JSON.stringify({ [this.idParamValue]: ids, ...extra })
    })
  }
}
